import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { formatDateTime, WindowType } from "../../../../util";
import { CommentReply } from "../../../backend/backendapi";
import { TextareaAutogrowDirective } from 'vue-textarea-autogrow-directive';
import TextSuggest from '../../../textsuggest/TextSuggest';

declare var window: WindowType;

@Component({
    name: 'ReplyComponent',
    components: {
        TextSuggest,
    },
    directives: {
        'autogrow': TextareaAutogrowDirective,
    }
})
export default class ReplyComponent extends Vue {
    @Prop({ required: true })
    reply!: CommentReply;
    @Prop({ required: true })
    userEmails!: string[];
    @Prop({ default: false })
    readonly!: boolean;
    @Prop({ default: false })
    lockeddown!: boolean;
    @Prop({ default: false })
    openAsEdit!: boolean;

    private editReply: string | null = null;

    mounted(): void {
        if (this.openAsEdit)
            this.editReply = this.reply.text;
    }

    private get userId(): string {
        return window.application.kanban.user?.id!;
    }

    private get userNameShort(): string {
        return this.reply.aspNetUser?.firstName?.substring(0, 1) + '' + this.reply.aspNetUser?.lastName?.substring(0, 1);
    }

    private get userFullName(): string {
        return this.reply.aspNetUser?.firstName + ' ' + this.reply.aspNetUser?.lastName;
    }

    //
    private save(): void {
        this.$emit('reply-save', this.reply, this.editReply);

        this.editReply = null;
    }

    private deleteReply(): void {
        this.$emit('reply-delete', this.reply);
    }

    private cancel(): void {
        this.editReply = null;
        this.$emit('reply-cancel', this.reply);
    }

    //util
    private formatDateTime(d: Date | undefined): string {
        if (!d)
            return '';
        return formatDateTime(d);
    }
}